import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { PatientService, Puser, ScrollToBottomDirective, User, UserService } from '../../shared';
import { SWF } from '../../shared/models';
declare function downloadImg(): any;
declare function showMarkerArea(): any;

@Component({
  templateUrl: 'messages.component.html',
  styleUrls: ['./style.component.css']
})
export class MessageComponent implements OnInit {
  imageURL: string = environment.cloudeImageURL;
  cid: any;
  i: any;
  menustatus: boolean = false;
  twowaymsg: boolean = false;
  chckinsurvey: boolean = false;

  menu: any;
  @ViewChild(ScrollToBottomDirective)
  scroll: ScrollToBottomDirective;

  messinfo: any;
  patswfid: any;
  public data: Object;
  messagesid: any;
  resp: any;
  PUser: Puser;
  CurrentUser: User;
  messages: any;
  apiurl: any = environment.api_url;
  SWF: SWF;
  imageChangedEvent: any;
  croppedImage: string;
  cropperReady: boolean;
  modalRef: any;
  timealert: number = environment.timelimit;
  imgMaxSize: any = environment.imagefileSize;
  upimage: any;
  outOfOfficeReason: string = '';
  fromDate:string="";
toDate:string="";
displayReason:string="";
outOfOfficeMasterId:number;

  constructor(
    private route: ActivatedRoute,  
    private router: Router,
    private userService: UserService,
    private toast: ToastrService,
    private patientService: PatientService,
    private modalService: BsModalService,
  ) {

  }



  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;

      }
    )
    if (this.route.snapshot.url[0].path != 'assessment') {
      this.CurrentUser.operationStatus = ''
    }
    this.userService.PUser.subscribe(
      (puserData) => {
        this.resp = puserData;
        this.PUser = puserData;

      }
    )

    if (this.CurrentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;


    if (window.localStorage['ccdetails']) {
      let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
      this.cid = ccdetails.cnuseraccid
    } else {
      this.cid = this.CurrentUser.item.userAccountId
    }
    this.userService.getmessages(window.localStorage['Puser'], this.cid)
      .subscribe(
        data => {
          this.messages = data;
          /*** Today Changes start here ***/
          if (this.messages.length > 0) {
            this.selectmessage(this.messages[0], 0)
            this.messages[0].open = true
            this.messages[0].active = true
          }
        }
      );

    this.getmenu()
  }
  markasunread(msginfo) {
    this.patientService.markasunread(window.localStorage['Puser'], msginfo.ccUserAccountId, 'patient')
      .subscribe(
        data => {
          if (data) {
            msginfo.unReadMsgCount = 1
            this.getmsgcount();
            // if(msginfo.active){
            //   setTimeout(() => {
            //     msginfo.unReadMsgCount = 0
            //     this.emitmsg(msginfo)
            //   }, 3000);
            // }
          }
        })
  }
  getmenu() {
    this.userService.postuserinfoid('1', this.CurrentUser.item.userAccountId)
      .subscribe(
        data => {
          this.menu = data[1].menu;

          if (this.menu) {
            for (var i = 0; i < this.menu.length; i++) {
              if (this.menu[i].refName == 'PAT_TWOWAYMESSAGE') {
                this.menustatus = this.menu[i].status

              }
              else if (this.menu[i].refName == 'DIS_PAT_TWOWAYMESSAGE') {
                this.twowaymsg = this.menu[i].status
              }
              else if (this.menu[i].refName == 'DIS_PAT_CKCH_SURVEY') {
                this.chckinsurvey = this.menu[i].status
              }
            }
          }
        })


  }
  emitmsg(msg) {
    let mode = 'P'
    this.patientService.getppmessagesinfo(msg.ccUserAccountId, window.localStorage['Puser'], mode, msg.type)
      .subscribe(
        data => {
          this.getmsgcount()

        }

      );
  }
  getmsgcount() {
    if (this.cid)
      this.userService.msgcountPP(this.cid)
        .subscribe(
          data => {
            this.CurrentUser.item.msgcount = data.UnReadTotalMsgCount
            this.userService.currentUserSubject.next(this.CurrentUser);
          })
  }
  selectmessage(msg, index) {
    this.patswfid = window.localStorage['Puser']
    this.messages[index].open = true;
    this.messages[index].active = true
    msg.unReadMsgCount = 0
    this.messinfo = [];
    this.i = index
    let mode = 'P';
    this.userService.fetchUserStatus(msg.ccUserAccountId)
			.subscribe( res => {
        this.outOfOfficeMasterId = res?.outOfOfficeMasterId || 2;
				if(res?.outOfOfficeMasterId && res?.outOfOfficeMasterId == 1){
					this.outOfOfficeReason = res.outOfOfficeReason || '';
          this.fromDate = res.outOfOfficeFromDate.split(' ')[0]; 
          this.toDate   = res.outOfOfficeToDate.split(' ')[0];
          this.displayReason=res;
				} 
		});
    this.patientService.getppmessagesinfo(msg.ccUserAccountId, this.patswfid, mode, msg.type)
      .subscribe(
        data => {
          this.messinfo = data;
          this.messinfo.name = msg.name
          this.messinfo.role = msg.role
          this.messinfo.type = msg.type
          this.messinfo.imagePath = msg.imagePath
          this.getmsgcount()

        }

      );
  }
  changeTab(e, i) {
    // this.messages[i].open=true;
    // this.messages[i].active = true
  }
  deselectTab(e, i) {
    this.messages[i].open = false;
  }
  submitmsg(msg) {
      if (this.outOfOfficeMasterId === 1) {
    return;
  }
  
    let msgobj = {
      ccUserAccountId: this.messages[this.i].ccUserAccountId,
      description: msg.value.message,
      patientSwfId: this.patswfid
    }

    this.patientService.savemsgpp(msgobj)
      .subscribe(
        data => {

          this.toast.success(data.message);
          this.userService.logAudit('saveTwoWayMessageSentByPatient', 0).subscribe(data => { })
          this.selectmessage(this.messages[this.i], this.i)
          msg.resetForm()

        }
    
      );
  }
  gettime(date) {
    date = date.split(' ')
    if (date.length > 3)
      return date[1] + ' ' + date[2] + ' ' + date[3]
    else
      return date[1] + ' ' + date[2]
  }
  getdate(date) {
    date = date.split(' ')
    return date[0]
  }
  document(template: TemplateRef<any>) {
    this.croppedImage = '';
    this.modalRef = this.modalService.show(template, {
      class: 'modal-lg wide',
      backdrop: 'static'
    })
    showMarkerArea();
  }
  fileChangeEvent(event: any): void {
    this.croppedImage = '';
    this.imageChangedEvent = event;
    if (event.target.files.length > 0) {
      this.upimage = event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(this.upimage);
      reader.onload = (_event) => {
        this.upimage = reader.result;
      }

      //console.log(this.rc_image)
    }
    let acceptFormat = ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg']
    //console.log(this.imageChangedEvent.srcElement);
    if (!acceptFormat.includes(this.imageChangedEvent.srcElement.files[0].type)) {
      this.toast.error(this.userService.translateText('patient_portal.validations.file_not_allowed.error_label'), '', {
        timeOut: this.timealert
      })
      this.imageChangedEvent = "";
      // this.croppedImage = this.defaultUl;
      return;
    } else if (this.imageChangedEvent.srcElement.files[0].size > this.imgMaxSize) {
      this.toast.error(this.userService.translateText('patient_portal.validations.maximum_size_exceed.error_label'), '', {
        timeOut: this.timealert
      })
      this.imageChangedEvent = "";
      // this.croppedImage = this.defaultUl;
      return;
    }
    // this.uploadfile='';
    // //console.log(this.imageChangedEvent.srcElement.files[0].name);
  }


  imageCropped(image: string) {
    this.croppedImage = image;

    // //console.log(this.croppedImage);
  }
  imageLoaded() {


    this.cropperReady = true;
  }
  imageLoadFailed() {
    //console.log('Load failed');
  }
  public pad: any = {

  };
  clearall() {
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.pad.note = '';
    this.upimage = ''
    window.localStorage.removeItem('imgEditor')
  }
  postdoc() {
    // this.upimage = window.localStorage['imgEditor']
    if (this.upimage != undefined) {
      // //console.log("in", this.title, this.note);
      //this.upimage = window.localStorage['imgEditor']
      let datapost = {
        "postimg": {
          "description": '',
          "attachmentPath": "",
          "attachmentType": 'png',
          "ccUserAccountId": this.messages[this.i].ccUserAccountId,
          "patientSwfId": parseInt(this.patswfid),
          "title": "",
          "attachment": {
            "filename": 'Download',
            "filetype": 'png',
            "value": this.upimage.split(',')[1]
          }
        },
        "portal": 'patient'
      };
      this.patientService.postattachment(datapost.postimg, datapost.portal)
        .subscribe(
          data => {
            if (data.status == 'success') {
              this.clearall()
              this.toast.success(data.message, '', {
                timeOut: this.timealert
              });
              this.userService.logAudit('saveTwoWayMessageSentByPatient', 0).subscribe(data => { })
              this.selectmessage(this.messages[this.i], this.i)
            } else {
              this.toast.error(data.message, '', {
                timeOut: this.timealert
              });
            }
          }
        );

    }


  }
  @HostListener('document:click', ['$event'])
  pop_up_over(event) {
    if (event.target.className == 'tui-image-editor-download-btn') {
      this.upimage = downloadImg()
      var aa = $('input.tui-image-editor-load-btn').val();
      if (aa != '') {
        setTimeout(() => {
          this.postdoc();
          this.modalRef.hide()
        }, 20);
      }
    }

    // Get the modal
    if (event.target.localName == 'img' && event.target.id && event.target.id != 'croppimg') {
      var modal = document.getElementById("myModal");
      modal.style.display = "block";
      // Get the image and insert it inside the modal - use its "alt" text as a caption
      var img = document.getElementById(event.target.id) as any as HTMLImageElement;
      var modalImg = document.getElementById("img01") as any as HTMLImageElement;
      var captionText = document.getElementById("caption") as any as HTMLImageElement;
      modalImg.src = img.src;
      captionText.innerHTML = img.alt;
      // Get the <span> element that closes the modal
      //var span = document.getElementsByClassName("close")[0];
    }

  }
  close_pop() {
    var modal = document.getElementById("myModal");
    modal.style.display = "none";
  }
}